import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5010Service } from '../../CSPService/CSP5010/csp5010.service';
import { Csp5010Class } from '../../CSPClass/CSP5010/csp5010-class';
import {FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '../../../../../../../src/environments/environment';

@Component({
  selector: 'kt-csp5010-view',
  templateUrl: './csp5010-view.component.html',
  styleUrls: ['./csp5010-view.component.scss']
})
export class Csp5010ViewComponent implements OnInit {

  lblPageTitle: string = "";
  ImageBse64:string;
  currentUrl:string;
  photoURL:string;
  Form:FormGroup;
  activeTab: 'course' | 'communication' | 'documents' = 'course';
  documentsList: any[] = [];
  constructor(private formBuilder: FormBuilder,private router: Router,public dialogRef: MatDialogRef<Csp5010ViewComponent>, private objCsp5010Service:Csp5010Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.ImageBse64= "";
    this.currentUrl =  environment.baseUrl.replace("api/", "");
    this.photoURL = "UploadFiles/DocManager/Default/photo.png";
     this.Form = this.formBuilder.group({
         
          BranchName: ['', Validators.required],
          CandidateName: ['', Validators.required],
          Year: ['', Validators.required],
          AdmittedTo: ['', Validators.required],
          ApplicationCategory: ['', Validators.required],
          Gender: ['', Validators.required],
          DateofBirth: ['', Validators.required],
          BloodGroup: ['', Validators.required],
          Nationality: ['', Validators.required],
          Religion: ['', Validators.required],
          Caste: ['', Validators.required],
          StudentCategory: ['', Validators.required],
          UID: ['', Validators.required],
          BranchPreference: ['', Validators.required],
          SystemRegistrationNo: ['', Validators.required],
          SystemAdmissionNo: ['', Validators.required],
          UniversityRegistrationNo: ['', Validators.required],
          UniversityAdmissionNo: ['', Validators.required],
          StudentStatus: ['', Validators.required],


          AddressforCommunication: ['', Validators.required],
          PinCode1: ['', Validators.required],  
          Taluk1: ['', Validators.required],    
          District1: ['', Validators.required],  
          State1: ['', Validators.required],  
          LandphoneNo: ['', Validators.required],  
          CandidatesMobNo: ['', Validators.required],  
          FathersName: ['', Validators.required],  
          FathersOccupation: ['', Validators.required],  
          FathersMobNo: ['', Validators.required],  
          MothersName: ['', Validators.required],  
          MothersOccupation: ['', Validators.required],  
          MothersMobileNo: ['', Validators.required],  
          AnnualIncome: ['', Validators.required],
          CurrentYear: ['', Validators.required],
          CurrentSemester: ['', Validators.required],  
          PermanentAddress: ['', Validators.required],  
          PinCode2: ['', Validators.required],
          Taluk2: ['', Validators.required],  
          District2: ['', Validators.required],  
          State2: ['', Validators.required],  
          PhoneNo: ['', Validators.required], 
          MobileNo: ['', Validators.required],
          CollegeEmail: ['', Validators.required],     
        });
    
          this.onGetDatas();

  }
      uint8ArrayToBase64(bytes: Uint8Array): string {
        let binary = '';
        for (let i = 0; i < bytes.length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary);
      }

      hexToUint8Array(hex: string): Uint8Array {
        // remove 0x if present
        hex = hex.startsWith('0x') ? hex.slice(2) : hex;

        const bytes = new Uint8Array(hex.length / 2);
        for (let i = 0; i < hex.length; i += 2) {
          bytes[i / 2] = parseInt(hex.substr(i, 2), 16);
        }
        return bytes;
      }

   onGetDatas() {
      if (localStorage.getItem('currentUser') != null) {
      var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
      var classobj = new Csp5010Class();
      classobj.UserNam= userLoginDetails.UserNam;
        this.objCsp5010Service.Profile(classobj).subscribe((data) => {
        //CourseDetails Tab Begin Section
        this.Form.controls['BranchName'].setValue(data.Item1[0].branch_nam);
        this.Form.controls['CandidateName'].setValue(data.Item1[0].student_name);
        this.Form.controls['Year'].setValue(data.Item1[0].year_code);
        this.Form.controls['AdmittedTo'].setValue(data.Item1[0].course_name);
        this.Form.controls['ApplicationCategory'].setValue(data.Item1[0].appl_category_name);
        this.Form.controls['Gender'].setValue(data.Item1[0].gender);
        this.Form.controls['DateofBirth'].setValue(data.Item1[0].dateofbirth);
        this.Form.controls['BloodGroup'].setValue(data.Item1[0].bloodgrp);
        this.Form.controls['Nationality'].setValue(data.Item1[0].natnly);
        this.Form.controls['Religion'].setValue(data.Item1[0].rlgn_nam);
        this.Form.controls['Caste'].setValue(data.Item1[0].caste_nam);
        this.Form.controls['StudentCategory'].setValue(data.Item1[0].student_category_name);
        this.Form.controls['UID'].setValue(data.Item1[0].student_uid);
        this.Form.controls['BranchPreference'].setValue(data.Item1[0].branch_preference);
        this.Form.controls['SystemRegistrationNo'].setValue(data.Item1[0].sys_registration_no);
        this.Form.controls['SystemAdmissionNo'].setValue(data.Item1[0].sys_admission_no);
        this.Form.controls['UniversityRegistrationNo'].setValue(data.Item1[0].university_registration_no);
        this.Form.controls['UniversityAdmissionNo'].setValue(data.Item1[0].university_admission_no);
        this.Form.controls['StudentStatus'].setValue(data.Item1[0].student_status);
        //CourseDetails Tab End Section

         //CommunicationDetails Tab Begin Section
         this.Form.controls['AddressforCommunication'].setValue(data.Item1[0].address_communication);
         this.Form.controls['PinCode1'].setValue(data.Item1[0].pincode);
         this.Form.controls['Taluk1'].setValue(data.Item1[0].taluk);
         this.Form.controls['District1'].setValue(data.Item1[0].district);
         this.Form.controls['State1'].setValue(data.Item1[0].state_nam_communication);
         this.Form.controls['LandphoneNo'].setValue(data.Item1[0].phone_no);
         this.Form.controls['CandidatesMobNo'].setValue(data.Item1[0].candidate_mobile_no);
         this.Form.controls['FathersName'].setValue(data.Item1[0].father_name);
         this.Form.controls['FathersOccupation'].setValue(data.Item1[0].father_occupation);
         this.Form.controls['FathersMobNo'].setValue(data.Item1[0].father_mobile_no);
         this.Form.controls['MothersName'].setValue(data.Item1[0].mother_name);
         this.Form.controls['MothersOccupation'].setValue(data.Item1[0].mother_occupation);
         this.Form.controls['MothersMobileNo'].setValue(data.Item1[0].mother_mobile_no);
         this.Form.controls['AnnualIncome'].setValue(data.Item1[0].annual_income);
         this.Form.controls['CurrentYear'].setValue(data.Item1[0].year_code_current);
         this.Form.controls['CurrentSemester'].setValue(data.Item1[0].semester_descr_current);
         this.Form.controls['PermanentAddress'].setValue(data.Item1[0].permanent_address);
         this.Form.controls['PinCode2'].setValue(data.Item1[0].permanent_pincode);
         this.Form.controls['Taluk2'].setValue(data.Item1[0].permanent_taluk);
         this.Form.controls['District2'].setValue(data.Item1[0].permanent_district);
         this.Form.controls['State2'].setValue(data.Item1[0].state_nam_permanent);
         this.Form.controls['PhoneNo'].setValue(data.Item1[0].permanent_phone_no);
         this.Form.controls['MobileNo'].setValue(data.Item1[0].permanent_mobile);
         this.Form.controls['CollegeEmail'].setValue(data.Item1[0].college_email);
         this.changeDetectorRef.detectChanges();
        //CommunicationDetails Tab End Section
        //Documents Tab Begins
        this.documentsList = data.Item2 || [];
         //Documents Tab Ends



      });

          this.objCsp5010Service.LoadImage(classobj).subscribe((data) => {
          this.ImageBse64 =data[0].ProfileImageBase64;
          this.changeDetectorRef.detectChanges();
      });
      this.changeDetectorRef.detectChanges();
    }
  }
   
  onClose() {


  if (this.dialogRef) {
    this.dialogRef.close();
  }
}

   getComponentTitle() {
    let result =  "My profile";
    return result;
   }
}
